<template>
    <div
        class="bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg mb-5 pb-5"
    >
        <header class="px-5 py-4 flex flex-row justify-between">
            <h2 class="font-semibold text-gray-800 text-base lg:text-xl">
                {{ user.name }}'s Points
            </h2>

            <div class="">
                <button
                    class="mr-2 border-none outline-none focus:outline-none px-2"
                >
                    <i class="far fa-angle-right text-xl text-gray-400"></i>
                </button>
            </div>
        </header>
        <div class="collapse-row">
            <div
                v-if="user.unmatched_accounts.length > 0"
                class="border-l-4 border-orange bg-orange-50 px-4 py-2 mb-2"
            >
                <div class="flex">
                    <div class="flex-shrink-0">
                        <svg
                            class="h-5 w-5 text-orange"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 16"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </div>
                    <div class="ml-3">
                        <p class="text-xs text-orange flex flex-wrap max-w-xs">
                            You have
                            {{ user.unmatched_accounts.length }} unmatched
                            card{{
                                user.unmatched_accounts.length === 1 ? '' : 's'
                            }}
                            in your wallet.
                            <a
                                href="/wallet"
                                class="font-medium text-orange underline hover:text-orange-600"
                            >
                                Please match these so that we can correctly sync
                                your rewards.
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-4 px-5 mb-8">
                <div class="col-span-12 border-b border-gray-200">
                    <ul
                        class="mb-3 flex flex-row text-xs md:text-sm"
                        v-if="filters.length"
                    >
                        <li
                            class="pr-3"
                            :class="{
                                'text-orange': filterProgramType === 'all',
                            }"
                            v-if="filters.length > 1"
                        >
                            <a
                                href="#"
                                role="button"
                                @click.prevent="filterProgramType = 'all'"
                            >
                                View All
                            </a>
                        </li>
                        <li
                            v-for="(filter, index) in filters"
                            class="px-3"
                            :class="{
                                'text-orange':
                                    filterProgramType === filter.value,
                            }"
                            :key="'filter-' + index"
                        >
                            <a
                                href="#"
                                role="button"
                                @click.prevent="
                                    filterProgramType = filter.value
                                "
                            >
                                {{ filter.label }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-if="programs.length === 0">
                <div class="bg-white overflow-hidden mb-5 py-10">
                    <div class="container mx-auto max-w-6xl px-4 py-4">
                        <div class="max-w-2xl rx m-auto">
                            <div class="text-center px-4">
                                <div
                                    class="flex items-center justify-center rounded-full mb-4"
                                >
                                    <svg
                                        class="w-24"
                                        version="1.1"
                                        viewBox="0 0 60 60"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                    >
                                        <defs>
                                            <linearGradient
                                                id="e"
                                                x1="50%"
                                                x2="50%"
                                                y2="100%"
                                            >
                                                <stop
                                                    stop-color="#F3F5F9"
                                                    offset="0"
                                                />
                                                <stop
                                                    stop-color="#E2E8F0"
                                                    offset="1"
                                                />
                                            </linearGradient>
                                            <rect
                                                id="b"
                                                width="60"
                                                height="60"
                                                rx="30"
                                            />
                                            <polygon
                                                id="c"
                                                points="0 0 8.4211 0 8.4211 11.579 0 11.579"
                                            />
                                        </defs>
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(-850 -303)">
                                                <g
                                                    transform="translate(560 303)"
                                                >
                                                    <g
                                                        transform="translate(290)"
                                                    >
                                                        <mask
                                                            id="a"
                                                            fill="white"
                                                        >
                                                            <use
                                                                xlink:href="#b"
                                                            />
                                                        </mask>
                                                        <use
                                                            fill="url(#e)"
                                                            xlink:href="#b"
                                                        />
                                                        <path
                                                            d="m15.217 28.895h-5.2171c0.28876-4.4211 2.0367-8.4442 4.7599-11.579l3.6611 3.7247c-1.7792 2.1703-2.9395 4.8827-3.204 7.8543"
                                                            fill="#F27249"
                                                            mask="url(#a)"
                                                        />
                                                        <path
                                                            d="m27.895 16.184c-2.9736 0.26723-5.6877 1.4393-7.8595 3.2366l-3.7194-3.6906c3.1426-2.7076 7.1637-4.4432 11.579-4.7304v5.1844z"
                                                            fill="#FD411D"
                                                            mask="url(#a)"
                                                        />
                                                        <path
                                                            d="m32.226 32.672c-0.462 0.90249-1.4673 1.4856-2.561 1.4856-1.5565 0-2.8228-1.1519-2.8228-2.5678 0-0.88186 0.48882-1.692 1.3076-2.1671l8.1661-4.7388-4.0899 7.9881z"
                                                            fill="#FD411D"
                                                            mask="url(#a)"
                                                        />
                                                        <path
                                                            d="m38.912 19.421c-2.1719-1.7972-4.8862-2.9693-7.8599-3.2365v-5.1846c4.4154 0.2872 8.4362 2.0235 11.579 4.7311l-3.7191 3.69z"
                                                            fill="#48B0D9"
                                                            mask="url(#a)"
                                                        />
                                                        <g mask="url(#a)">
                                                            <g
                                                                transform="translate(41.579 17.316)"
                                                            >
                                                                <mask
                                                                    id="d"
                                                                    fill="white"
                                                                >
                                                                    <use
                                                                        xlink:href="#c"
                                                                    />
                                                                </mask>
                                                                <path
                                                                    d="m3.2035 11.579c-0.26449-2.9715-1.4245-5.6838-3.2035-7.8542l3.6606-3.7248c2.7229 3.1348 4.4717 7.1579 4.7604 11.579h-5.2176z"
                                                                    fill="#213E4A"
                                                                    fill-rule="evenodd"
                                                                    mask="url(#d)"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <h2
                                    class="text-2xl text-gray-800 font-bold mb-3"
                                >
                                    Start Tracking Your Points
                                </h2>
                                <div class="mb-12 relative">
                                    <p
                                        class="mt-6 text-lg leading-8 text-gray-600"
                                    >
                                        Sync your loyalty accounts to start
                                        tracking your points & miles.
                                    </p>

                                    <p
                                        class="mt-6 text-lg leading-8 text-gray-600 font-bold"
                                    >
                                        You have 2 options to manage your
                                        points:
                                    </p>
                                    <ol
                                        class="list-decimal mt-6 text-lg leading-8 text-gray-600 text-left"
                                    >
                                        <li class="mb-3">
                                            Automatically sync many popular
                                            rewards currencies by first
                                            connecting your issuing bank in My
                                            Wallet.
                                        </li>
                                        <li class="mb-3">
                                            Manually track your points
                                            (including currencies that don't
                                            offer syncing in My10x) by adding a
                                            manual points program below.
                                        </li>
                                    </ol>
                                </div>
                                <div
                                    class="flex flex-col justify-center lg:flex-row lg:justify-between relative"
                                >
                                    <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 43.1 85.9"
                                        style="
                                            enable-background: new 0 0 43.1 85.9;
                                        "
                                        xml:space="preserve"
                                        class="animated-arrow absolute -top-12 -right-28 hidden lg:block"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="st0 draw-arrow"
                                            d="M11.3,2.5c-5.8,5-8.7,12.7-9,20.3s2,15.1,5.3,22c6.7,14,18,25.8,31.7,33.1"
                                        />
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="draw-arrow tail-1"
                                            d="M40.6,78.1C39,71.3,37.2,64.6,35.2,58"
                                        />
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="draw-arrow tail-2"
                                            d="M39.8,78.5c-7.2,1.7-14.3,3.3-21.5,4.9"
                                        />
                                    </svg>

                                    <a
                                        href="/wallet/"
                                        class="btn btn-orange"
                                        role="button"
                                    >
                                        <svg
                                            class="w-4 h-4 flex-shrink-0"
                                            viewBox="0 0 16 16"
                                            fill="#334155"
                                        >
                                            <path
                                                d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z"
                                            />
                                        </svg>
                                        <span class="hidden xs:block ml-2">
                                            Connect to Issuing Bank
                                        </span>
                                    </a>
                                    <a
                                        href="#"
                                        class="btn btn-gray"
                                        @click.prevent="
                                            showProgramModalAction(user)
                                        "
                                        role="button"
                                    >
                                        <svg
                                            class="w-4 h-4 flex-shrink-0"
                                            viewBox="0 0 16 16"
                                            fill="#F27249"
                                        >
                                            <path
                                                d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z"
                                            />
                                        </svg>
                                        <span class="hidden xs:block ml-2">
                                            Add Manual Points Program
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="loyalty-programs grid grid-cols-12 px-5 mt-5 mb-5 gap-4"
            >
                <program-card
                    v-for="(program, index) in sortedPrograms"
                    :program="program"
                    :user="user"
                    :key="'program-' + index"
                ></program-card>

                <award-booking-program-card></award-booking-program-card>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { usePointsStore } from '@/store/points';

import ProgramCard from '@/components/mypoints/program-card.vue';
import AwardBookingProgramCard from '@/components/mypoints/award-booking-program-card.vue';

export default {
    components: {
        ProgramCard,
        AwardBookingProgramCard,
    },
    props: {
        user: Object,
    },
    data: () => ({
        errors: [],
        loading: false,
        filterProgramType: 'all',
        programFilters: [
            { label: 'Airline', value: 'airline' },
            { label: 'Cashback', value: 'cashback' },
            { label: 'Hotels', value: 'hotel' },
            { label: 'Flexible Currency', value: 'flexible_currency' },
        ],
    }),
    computed: {
        ...mapState(usePointsStore, [
            'rewards',
            'programs',
            'reward',
            'addRewardUser',
            'showProgramModal',
            'showEditProgramModal',
        ]),
        sortedPrograms() {
            let sortedItems = this.programsFiltered;
            return sortedItems.sort((a, b) => {
                return b.points - a.points;
            });
        },
        filters() {
            return this.programFilters.filter((filter) => {
                return this.user.programs.some((e) => e.type === filter.value);
            });
        },
        programsFiltered() {
            return this.programs.filter((program) => {
                return this.filterProgramType === 'all'
                    ? program
                    : this.filterProgramType === program.type;
            });
        },
        programs() {
            return this.user.programs.filter((program) => {
                return !program.converted_to_manual;
            });
        },
        hasEliteStatus() {
            return (
                this.program.program_user &&
                this.program.program_user.has_elite_status === 'Y'
            );
        },
        programStatus() {
            return this.program.program_user
                ? this.titleCase(this.program.program_user.elite_status)
                : null;
        },
        programStatusDate() {
            return this.program.expire_day
                ? this.program.expire_day +
                      '/' +
                      this.program.expire_month +
                      '/YYYY'
                : '';
        },
    },
    methods: {
        ...mapActions(usePointsStore, ['showProgramModalAction']),
        titleCase(str) {
            return String(str)
                .toLowerCase()
                .split(' ')
                .map(function (word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(' ');
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="scss" scoped>
/*https://codepen.io/ahebler/pen/YXJJWb*/
svg.animated-arrow {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    transform: scaleX(-1) rotate(-33deg);
    .draw-arrow {
        stroke-width: 3;
        stroke: #fd421d;
        fill: none;
        stroke-dasharray: 400;
        stroke-dashoffset: 400;
        animation-duration: 2s;
        animation-delay: 2s;
        animation-fill-mode: forwards;
        animation-name: draw;
        &.tail-1 {
            animation-delay: 2.5s;
        }
        &.tail-2 {
            animation-delay: 2.7s;
        }
    }
}
@keyframes draw {
    to {
        stroke-dashoffset: 0;
    }
}
</style>
